import * as types from '../../lib/actionTypes.es6';

function creator(type) {
  return function create(payload) {
    return { type: type, payload: payload };
  };
}

export var getCommissionSettingsRequest =
  creator(types.GET_COMMISSION_SETTINGS_REQUEST);
export var getCommissionSettingsSuccess =
  creator(types.GET_COMMISSION_SETTINGS_SUCCESS);
export var getCommissionSettingsFailed =
  creator(types.GET_COMMISSION_SETTINGS_FAILURE);

export var updateCommissionSettingsRequest =
  creator(types.UPDATE_COMMISSION_SETTINGS_REQUEST);
export var updateCommissionSettingsSuccess =
  creator(types.UPDATE_COMMISSION_SETTINGS_SUCCESS);
export var updateCommissionSettingsFailed =
  creator(types.UPDATE_COMMISSION_SETTINGS_FAILURE);
export var resetUpdateCommissionSettings =
  creator(types.RESET_UPDATE_COMMISSION_SETTINGS);
